<template>
  <div class="user-comments">
    <UserTitle title="相关评论" :border="true"></UserTitle>
    <div class="spin-margin" v-if="loading">
      <a-spin>
        <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
      </a-spin>
    </div>
    <div v-if="!loading">
      <div
        class="comments-content"
        v-if="commentData && commentData.length > 0"
      >
        <!-- 用户信息 -->
        <div v-for="(item, index) in commentData" :key="index">
          <div class="comments-user">
            <div class="comments-user-title" v-if="item.user">
              <img
                v-if="item.user && item.user.avatar"
                :src="getImgUrl(item.user.avatar)"
              />
              <a-avatar v-else :size="60" icon="user" />
              <div class="comments-user-text">
                <h5>{{ item.user ? item.user.nickname : "" }}</h5>
                <p>
                  {{ $moment(item.createTime).format("YYYY-MM-DD hh:mm:ss") }}
                </p>
              </div>
            </div>
            <span>{{ item.comment }}</span>
          </div>
          <CMS :cmsType="item.objectType" :cmsId="item.objectId"></CMS>

          <div v-if="item.recomments && item.recomments.length > 0">
            <div class="comments-user">
              <div class="comments-user-title" v-if="item.user">
                <img :src="getImgUrl(item.user.avatar)" />
                <div class="comments-user-text">
                  <h5>{{ item.user ? item.user.nickname : "" }}</h5>
                  <p>
                    {{ $moment(item.createTime).format("YYYY-MM-DD hh:mm:ss") }}
                  </p>
                </div>
              </div>
              <span>{{ item.comment }}</span>
            </div>
            <div class="comments-report">
              <p
                class="maxLength-text-2"
                v-for="(items, index) in item.recomments"
                :key="index"
              >
                <a href>@{{ item.user ? item.user.nickname : "" }}</a>
                {{ items.comment }}
              </p>
            </div>
          </div>
        </div>
        <b-pagination
          v-if="page.show"
          class="ltitle-page solution-page"
          style="justify-content: center;"
          v-model="page.current"
          :total-rows="page.rows"
          :perPage="page.perPage"
          first-number
          last-number
        ></b-pagination>
      </div>
      <a-empty class="empty" description="暂无评论" v-else />
    </div>
  </div>
</template>
<script>
import CMS from "@/components/user/comment.vue";
import Api from "@/apis";
import publicChange from "@/assets/js/index.js";
export default {
  data() {
    return {
      active: 0,
      page: {
        current: 1,
        rows: 1,
        perPage: 2,
        show: false
      },
      commentData: [],
      loading: false,
      listData: {}
    };
  },
  components: {
    CMS
  },
  watch: {
    "page.current": {
      handler: function() {
        this.getCommentMine();
        window, scrollTo(0, 0);
      }
    }
  },
  mounted() {
    this.getCommentMine();
  },
  methods: {
    goDetails(id) {
      this.$router.push({
        path: "/new/details",
        query: {
          id: id
        }
      });
    },
    login() {
      return publicChange.userLogin();
    },
    //获取我的项目
    async getCommentMine() {
      const login = this.login();
      this.loading = true;
      if (login) {
        try {
          const query = {
            current: this.page.current,
            pageSize: this.page.perPage
          };
          const data = await Api.Comment.getCommentMine(query);
          let reportArr = [];
          if (data.data && data.data.length > 0) {
            data.data.map(item => {
              reportArr.push(item);
            });
            this.commentData = reportArr;
            this.page.show = true;
          } else {
            this.page.show = false;
          }
          this.loading = false;
          this.page.rows = data.total;
        } catch (e) {
          this.$message.error(e);
          //   else if (type == "project") {
          // const project = Api.Project.getProjectId(id);
          // return project;
        }
      }
    },
    //根据objectId获取详情
    getListData(type, id) {
      return new Promise((resovle, reject) => {
        if (type == "post") {
          const cms = Api.CMS.getCmsDeatil(id);
          return resovle(cms.title);
        } else {
          reject("233");
        }
      });
    },
    onDesc(text) {
      return publicChange.disposeHtml(text);
    },
    //转换时间戳
    changeDataTime(date) {
      let time = new Date(date);
      return this.$moment(time).format("YYYY.MM.DD");
    },
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    getDate(time) {
      return publicChange.getDate(time);
    }
    //切换
  }
};
</script>
<style scoped>
.comments-content {
  margin-bottom: 50px;
}
.comments-user {
  margin-top: 50px;
}
.comments-user-title {
  display: flex;
  align-items: center;
}
.comments-user-title img {
  width: 60px;
  height: 60px;
  object-fit: cover;
  border-radius: 50%;
  display: inline-block;
  margin-right: 20px;
}
.comments-user-title h5,
.comments-project h5 {
  font-size: 22px;
  font-weight: 400;
  color: #333333;
  line-height: 33px;
  text-align: left;
  margin-bottom: 5px;
}
.comments-user-title p,
.comments-project p {
  font-size: 16px;
  font-weight: 300;
  color: #666666;
  line-height: 24px;
  text-align: left;
}
.comments-user {
  display: flex;
  flex-direction: column;
}
.comments-project {
  text-align: left;
  border: 1px solid #f7f8ff;
  margin: 52px 24px 55px 24px;
  padding: 20px 15px;
}
.comments-user span,
.comments-project span {
  font-size: 16px;
  font-weight: 300;
  color: #666666;
  line-height: 24px;
  text-align: left;
  margin-top: 23px;
  display: inline-block;
}
.comments-project h5 {
  margin-bottom: 10px !important;
}
.comments-project span {
  margin-top: 0 !important;
  margin-bottom: 16px;
}
.comments-project img {
  height: 164px;
}
.comments-report p {
  font-size: 16px;
  font-weight: 300;
  color: #666666;
  line-height: 24px;
  text-align: left;
  margin-bottom: 5px !important;
}
.comments-report a {
  color: #3382ff;
}
.comments-report {
  padding: 24px 24px;
  margin: 44px 24px;
  border: 1px solid #f7f8ff;
}
</style>
